import React, { useEffect } from 'react';
import './Portfolio.css';
import Hero from './components/Hero/Hero';
import Projects from './components/Projects/Projects';
import Skills from './components/Skills/Skills';
import Experience from './components/Experience/Experience';
import Services from './components/Services/Services';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

const Portfolio = ({ scrollTo }) => {
  useEffect(() => {
    if (scrollTo) {
      // Esperar a que el componente se renderice completamente
      const timer = setTimeout(() => {
        const element = document.getElementById(scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [scrollTo]);

  return (
    <div className="portfolio">
      <Hero />
      <Projects />
      <Skills />
      <Experience />
      <Services />
      <About />
      <Contact />
      <Footer />
    </div>
  );
};

export default Portfolio;
